import { Slack, Mail, MessageSquare, MessagesSquare, Phone, Sparkles } from "lucide-react";

// Channel visual identity for multimodal Aria <-> employee communication.
export const CHANNEL_META = {
  slack: { label: "Slack", icon: Slack, color: "#8B5CF6", bg: "rgba(139,92,246,0.12)", border: "rgba(139,92,246,0.28)" },
  teams: { label: "Teams", icon: MessagesSquare, color: "#7B83EB", bg: "rgba(123,131,235,0.12)", border: "rgba(123,131,235,0.28)" },
  email: { label: "Email", icon: Mail, color: "#4F8EF7", bg: "rgba(79,142,247,0.12)", border: "rgba(79,142,247,0.28)" },
  text: { label: "Text", icon: MessageSquare, color: "#22C55E", bg: "rgba(34,197,94,0.12)", border: "rgba(34,197,94,0.28)" },
  call: { label: "Call", icon: Phone, color: "#F59E0B", bg: "rgba(245,158,11,0.12)", border: "rgba(245,158,11,0.28)" },
  system: { label: "System", icon: Sparkles, color: "#A3A3A3", bg: "rgba(163,163,163,0.10)", border: "rgba(163,163,163,0.20)" },
};

export const channelMeta = (channel) => CHANNEL_META[channel] || CHANNEL_META.system;

export const ChannelBadge = ({ channel, className = "" }) => {
  const m = channelMeta(channel);
  const Icon = m.icon;
  return (
    <span
      data-testid={`channel-badge-${channel}`}
      className={`inline-flex items-center gap-1 rounded-md px-1.5 py-[1px] text-[9.5px] font-medium ${className}`}
      style={{ background: m.bg, color: m.color }}
    >
      <Icon size={9} />
      {m.label}
    </span>
  );
};
